import React from 'react';

const CloseSvg = ({ color }) => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 4L3.5 11" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 4L10.5 11" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CloseSvg;
